module.exports = __webpack_public_path__ + "static/media/case-id-tooltip-pl.f036d8a4.jpg";